export function cleanMailHtml(html) {
  if (!html) return '';

  // Supprime les balises meta, style, link, commentaires HTML
  html = html
    .replace(/<meta[^>]*>/gi, '')
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
    .replace(/<link[^>]*>/gi, '')
    .replace(/<!--([\s\S]*?)-->/g, '');

  // Supprime les balises vides <p> ou <br> au début
  html = html.replace(/^(<br\s*\/?>|<p>\s*<\/p>)+/i, '');

  // Supprime les espaces ou retours à la ligne au début
  html = html.replace(/^\s+/, '');

  return html;
}
